import { WindowFrameAction } from './actions'

export interface State {
  /* Name of the active main-grid menu ('Client' | 'Admin' | ''). Lives in redux
     (not view-local) so the OpenFin WindowFrame's menu buttons can toggle the
     menu that renders in the authed main-grid view, bridged by redux-state-sync. */
  activeMenu: string
}

export const initialState: State = {
  activeMenu: ''
}

export default (state = initialState, action: WindowFrameAction): State => {
  switch (action.type) {
    case 'windowFrame.setActiveMenu':
      return { ...state, activeMenu: action.payload }
    default:
      return state
  }
}
